import { render, staticRenderFns } from "./productMatcher.vue?vue&type=template&id=8348841e&scoped=true&"
import script from "./productMatcher.vue?vue&type=script&lang=js&"
export * from "./productMatcher.vue?vue&type=script&lang=js&"
import style0 from "./productMatcher.vue?vue&type=style&index=0&id=8348841e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8348841e",
  null
  
)

export default component.exports